import autowebStore from "./vuex";
import routes from "./router";
import "./assets/style/editorTheme.scss";

/**
 * editor 样式控制器（新增）
 */
const EditorStyleController = (() => {
  let styleEl = null;
  let resizeHandler = null;
  let observer = null;

  const resize = () => {
    const w = document.documentElement.clientWidth;
    let max = 970;

    if (w < 768) {
      document.documentElement.removeAttribute("style");
      document.documentElement.classList.add("m");
    } else {
      if (w >= 1185) max = 1200;
      document.documentElement.style.fontSize = (max / 240) * 10 + "px";
      document.documentElement.classList.remove("m");
    }
  };

  const enable = () => {
    if (resizeHandler) return;

    // 注入全局字体样式
    styleEl = document.createElement("style");
    styleEl.id = "editor-global-font";
    styleEl.innerHTML = `* { font-size: 14px; }`;
    document.head.appendChild(styleEl);

    // resize
    resizeHandler = resize;
    window.addEventListener("resize", resizeHandler);
    resize();
  };

  const disable = () => {
    if (resizeHandler) {
      window.removeEventListener("resize", resizeHandler);
      resizeHandler = null;
    }

    if (styleEl) {
      styleEl.remove();
      styleEl = null;
    }

    document.documentElement.removeAttribute("style");
    document.documentElement.classList.remove("m");
  };

  const check = () => {
    const el = document.querySelector(".editor-main");

    if (el && el.offsetParent !== null) {
      enable();
    } else {
      disable();
    }
  };

  const observe = () => {
    if (observer) return;

    observer = new MutationObserver(() => {
      check();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true
    });

    check();
  };

  const destroy = () => {
    disable();
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  return {
    observe,
    destroy
  };
})();

export default {
  install(Vue, { store, router }) {
    router.addRoutes(routes);
    store.registerModule("autowebStore", autowebStore);

    // 👉 自动启动监听
    EditorStyleController.observe();

    // 可选：挂到 Vue 原型方便手动控制
    Vue.prototype.$editorStyleController = EditorStyleController;
  }
};